import useJumboFooterTheme from '@jumbo/hooks/useJumboFooterTheme';
import useJumboHeaderTheme from '@jumbo/hooks/useJumboHeaderTheme';
import useJumboSidebarTheme from '@jumbo/hooks/useJumboSidebarTheme';
import useJumboTheme from '@jumbo/hooks/useJumboTheme';
import { applyFontScaleToLayers, getStoredFontScale } from 'app/themes/fontScale';
import { useEffect, useRef } from 'react';

// Kayıtlı yazı kademesini Jumbo'nun dört katmanına uygular (ilk yükleme).
const FontScaleSync = () => {
    const { theme, setTheme } = useJumboTheme();
    const { headerTheme, setHeaderTheme } = useJumboHeaderTheme();
    const { sidebarTheme, setSidebarTheme } = useJumboSidebarTheme();
    const { footerTheme, setFooterTheme } = useJumboFooterTheme();
    const appliedRef = useRef(false);

    useEffect(() => {
        if (appliedRef.current) return;
        appliedRef.current = true;
        applyFontScaleToLayers({
            theme,
            setTheme,
            headerTheme,
            setHeaderTheme,
            sidebarTheme,
            setSidebarTheme,
            footerTheme,
            setFooterTheme,
        }, getStoredFontScale());
        // yalnızca ilk yüklemede
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default FontScaleSync;
